// material
import { Stack, Box, Typography, Button, Grid, Hidden, Container } from "@mui/material";
// import trendingUpFill from "@mui/icons-material/home"
// components
import MContainer from "components/MContainer";
import WaveIcon from "components/WaveIcon";
import ArrowIcon from "components/ArrowIcon";
import BlocksIcon from "components/BlocksIcon";
import ProductDisplay from "../components/ProductDisplay";
import CoreTeam from "./Homepage/CoreTeam";
import DevTeam from "./Homepage/DevTeam";
import Roadmap from "./Homepage/Roadmap";
import ContactUs from "./Homepage/ContactUs";
import AboutUs from "./Homepage/AboutUs";
import Products from "./Homepage/Products";
import Features from "./Homepage/Features";
import { useState, useEffect } from 'react';
import { styled, alpha } from "@mui/material/styles";
import { Link as ScrollLink } from "react-scroll";
import Store from '../Store';
import MainGameElements from './Homepage/MainGameElements';
// ----------------------------------------------------------------------

const LinkStyle = styled(Typography)(({ theme }) => ({
  fontSize: '12px !important',
  cursor: 'pointer',
  fontWeight: 400,
  color: "#7C8998",
  marginRight: theme.spacing(5),
  textDecoration: "none",
  transition: theme.transitions.create("color", {
    duration: theme.transitions.duration.shortest,
  }),
  "&:hover": {
    color: "#FFC107",
  },
  [theme.breakpoints.down("lg")]: {
    marginRight: theme.spacing(4)
  }
}));

const HeroButton = styled(Button)(({ theme }) => ({
  height: 46,
  borderRadius: "8px",
  fontSize: '16px',
  fontWeight: 600,
  padding: '0 24px',
  backgroundColor: '#FFFFFF',
  color: '#000000',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: '#F0F0F0',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.25)',
  }
}));

const TagLine = styled(Box)(({ theme }) => ({
  backgroundColor: '#A3E7FD',
  position: 'relative',
  display: 'inline-block', 
  padding: '8px 20px',
  borderRadius: '8px',
  marginTop: '16px',
  marginBottom: '20px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
}));

const SplashHeader = "Your Partner in Procurement"
const SplashSubHeader = "Expertise, quality, and exceptional service."

const HeroSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#0a3143',
  borderRadius: 0,
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
  marginBottom: '32px',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    height: '450px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '500px',
  },
  [theme.breakpoints.up('xl')]: {
    height: '600px',
  }
}));

const VideoBackground = styled('video')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  minWidth: '100%',
  minHeight: '100%',
  width: 'auto',
  height: 'auto',
  zIndex: 1,
  transform: 'translateX(-50%) translateY(-50%)',
  objectFit: 'cover',
});

const HeroContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 5,
  width: '100%',
  maxWidth: theme.breakpoints.values.lg,
  margin: '0 auto',
  padding: theme.spacing(0, 2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 3),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 4),
  }
}));

export default function Homepage() {
  
  return (
    <Box sx={{ position: "relative", width: 1 }}>
      
      <Hidden mdDown>
        <HeroSection >
          <Box
            component="img"
            src="/images/amd.jpg"
            alt="AMD EPYC Processor"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              zIndex: 1
            }}
          />
          <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 2 }}>
            <Box
              component="video"
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => {
                console.log("Video failed to load", e);
                e.target.style.display = 'none';
              }}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            >
              <source src="/images/background.mp4" type="video/mp4" />
            </Box>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 3,
              background: 'linear-gradient(105deg,rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.75) 40%,  rgba(0,0,0,0.5) 70%, rgba(0,0,0,0.2) 100%)',
            }}
          />
          <HeroContent>
            <Box sx={{ maxWidth: { sm: '70%', md: '60%', lg: '50%' } }}>
              <Typography 
                variant="h1" 
                sx={{
                  color: 'white',
                  lineHeight: 1.1,
                  fontSize: { lg: '3.5rem', md: '3rem' },
                  fontWeight: 700,
                  letterSpacing: '-0.02em',
                  mb: 2
                }}
              >
                {SplashHeader}
              </Typography>
              
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontSize: '1.1rem',
                  mb: 4
                }}
              >
                {SplashSubHeader}
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <a href="https://usm.channelonline.com/msco/storesite/" target="_blank" style={{ textDecoration: "none" }}>
                  <HeroButton>
                    Shop Now <ArrowIcon style={{ position: 'relative', top: '2px', left: '4px', transform: 'scale(0.55)' }} />
                  </HeroButton>
                </a>
              </Box>
            </Box>
          </HeroContent>
        </HeroSection>
      </Hidden>
      
      <Hidden mdUp>
        <HeroSection sx={{ mb: 3 }}>
          <Box
            component="img"
            src="/images/amd.jpg"
            alt="AMD EPYC Processor"
            sx={{ 
              width: '100%',
              display: 'block',
              height: 'auto',
              objectFit: 'cover'
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(to top, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0) 100%)',
              padding: { sm: '32px 24px 24px', xs: '24px 16px 16px' }
            }}
          >
            <Typography variant="h2" sx={{
              fontSize: { sm: '2rem', xs: '1.75rem' },
              lineHeight: 1.2,
              color: 'white',
              fontWeight: 700,
              mb: 1
            }}>
              {SplashHeader}
            </Typography>
            <Typography variant="body1" sx={{
              color: 'rgba(255, 255, 255, 0.85)',
              mb: 2,
              display: { xs: 'none', sm: 'block' }
            }}>
              {SplashSubHeader}
            </Typography>
            <Box sx={{ mt: 1 }}>
              <a href="https://usm.channelonline.com/msco/storesite/" target="_blank" style={{ textDecoration: "none" }}>
                <Button variant="contained" 
                  sx={{  
                    height: { sm: '44px', xs: '40px' },
                    borderRadius: "8px",
                    fontSize: { sm: '16px', xs: '14px' },
                    fontWeight: 600,
                    padding: '0 16px',
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    '&:hover': {
                      backgroundColor: '#F0F0F0'
                    }
                  }}>
                  Shop Now <ArrowIcon style={{ position: 'relative', top: '1px', left: '4px', transform: 'scale(0.5)' }} />
                </Button>
              </a>
            </Box>
          </Box>
        </HeroSection>
      </Hidden>
      
      <Store />
      <Features />
      <Products />
      <AboutUs />
      <ContactUs />
    </Box>
  );
}
